import { render, staticRenderFns } from "./WorkspaceIndex.vue?vue&type=template&id=3fbc7fc1&"
import script from "./WorkspaceIndex.vue?vue&type=script&lang=js&"
export * from "./WorkspaceIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports